export const KEY_CODES = {
  ENTER: 13,
  TAB: 9,
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  ESC: 27,
}



// WEBPACK FOOTER //
// ./src/constants/keyCodes.js